<script lang="ts" setup>
	import ShoppingcartComponent from '@/components/ShoppingcartComponent.vue';
</script>

<template>
	<div>
		<shoppingcart-component />
	</div>
</template>
